import { render, staticRenderFns } from "./ClickButton.vue?vue&type=template&id=5660602f&scoped=true&"
import script from "./ClickButton.vue?vue&type=script&lang=js&"
export * from "./ClickButton.vue?vue&type=script&lang=js&"
import style0 from "./ClickButton.vue?vue&type=style&index=0&id=5660602f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660602f",
  null
  
)

export default component.exports